import React from 'react';
import { Link } from 'react-router-dom';
import LineDotLong from '../../images/line-dot-long.png'

class UnavailableProduct extends React.Component { 
    render() {
        return <div className="container" style={{ width: "100%", minHeight: "38.8vh" }}>
            <div className="col-sm-12 row" style={{ margin: "50px auto" }}>
                <div className="col-xs-12">
                    <div className="col-sm-12 margin">
                        <h3>
                            Unavailable Product
                        </h3>
                    </div>
                    <img src={LineDotLong} />
                </div>
                <div className="col-sm-12 margin">
                    <p>
                        Product you entered does not exist. Please visit <Link to="/">Service Catalog</Link> to subscribe.
                        <br />
                        <br />
                        Otherwise please contact <a mailhref="mailto:igeoportal@iwk.com.my">igeoportal@iwk.com.my</a> for more enquiries.
                    </p>
                </div>
            </div>
        </div>;
    }
}
export default UnavailableProduct;



// WEBPACK FOOTER //
// ./src/components/Error/UnavailableProduct.js